import React, { useState, useEffect } from 'react';
import PhaseCurrentCheckBox from './PhaseCurrentCheckBox';
import { useTranslation } from 'react-i18next';

export type PhaseCurrentCheckBoxData = {
  isRDisp: boolean; //R相表示
  isSDisp: boolean; //S相表示
  isTDisp: boolean; //T相表示
  isPileup: boolean; //重ね合わせ
  isDCRemoval: boolean; //直流成分除去　DC component removal
};

type Props = {
  selectData: PhaseCurrentCheckBoxData;
  onSelectDataChangeEvent: (data: PhaseCurrentCheckBoxData) => void;
};

const PhaseCurrentCheckBoxList: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const tdStyle: React.CSSProperties = {};
  const tableStyle: React.CSSProperties = {
    borderCollapse: `collapse`,
  };

  const onRCheckBoxChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    console.debug('onRCheckBoxChange ' + event.target.value);
    var sDt = props.selectData;
    sDt.isRDisp = !sDt.isRDisp;
    props.onSelectDataChangeEvent(sDt);
  };
  const onSCheckBoxChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    console.debug('onSCheckBoxChange ' + event.target.value);
    var sDt = props.selectData;
    sDt.isSDisp = !sDt.isSDisp;
    props.onSelectDataChangeEvent(sDt);
  };
  const onTCheckBoxChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    console.debug('onTCheckBoxChange ' + event.target.value);
    var sDt = props.selectData;
    sDt.isTDisp = !sDt.isTDisp;
    props.onSelectDataChangeEvent(sDt);
  };
  const onPileupChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    console.debug('onPileupChange ' + event.target.value);
    var sDt = props.selectData;
    sDt.isPileup = !sDt.isPileup;
    props.onSelectDataChangeEvent(sDt);
  };
  const onDCRemovalChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    console.debug('onDCRemovalChange ' + event.target.value);
    var sDt = props.selectData;
    sDt.isDCRemoval = !sDt.isDCRemoval;
    props.onSelectDataChangeEvent(sDt);
  };

  return (
    <>
      <div style={{ display: 'flex' }}>
        <table>
          <tr>
            <td style={{ padding: '0px' }}>
              <PhaseCurrentCheckBox
                itemName={t('PhaseCurrentCheckBoxList.R相', 'R相')}
                color={'red'}
                isCheckd={props.selectData.isRDisp}
                onChange={onRCheckBoxChange}
              />
            </td>
            <td style={{ padding: '0px' }}>
              <PhaseCurrentCheckBox
                itemName={t('PhaseCurrentCheckBoxList.S相', 'S相')}
                color={'blue'}
                isCheckd={props.selectData.isSDisp}
                onChange={onSCheckBoxChange}
              />
            </td>
            <td style={{ padding: '0px' }}>
              <PhaseCurrentCheckBox
                itemName={t('PhaseCurrentCheckBoxList.T相', 'T相')}
                color={'green'}
                isCheckd={props.selectData.isTDisp}
                onChange={onTCheckBoxChange}
              />
            </td>
          </tr>
        </table>
        <table>
          <tr>
            <td>
              <input type="checkbox" onChange={onPileupChange} checked={props.selectData.isPileup} />
              {t('PhaseCurrentCheckBoxList.重ね合わせ', '重ね合わせ')}
            </td>
          </tr>
          <tr>
            <td>
              <input type="checkbox" onChange={onDCRemovalChange} checked={props.selectData.isDCRemoval} />
              {t('PhaseCurrentCheckBoxList.直流成分除去', '直流成分除去')}
            </td>
          </tr>
        </table>
      </div>
    </>
  );
};

export default PhaseCurrentCheckBoxList;
